import React, { useContext } from "react";
import AmountHistory from "../../components/Dashboard/AmountHistory";
import { useNavigate } from "react-router-dom";
import ThemeContext from "../../Context/theme/ThemeContext";
import axios from "axios";
import { BaseURL } from "../../Files/BaseURL";
import { useEffect, useState } from "react";

const WithdrawHistory = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [auth] = useState(localStorage.getItem("p@token"));

  const fetchUser = async () => {
    const response = await axios.get(`${BaseURL}/api/user/userstatus`, {
      headers: {
        "auth-token": auth,
        "Content-Type": "application/json",
      }
    });
    if (response) {
      setUser(response.data);
    }
  }

  useEffect(() => {
    fetchUser();
  }, [auth])

  return (
    <div className="px-3 md:px-6 py-6 ">
      <div className="flex flex-col md:flex-row gap-4">
        <div
          className={`  w-fit md:w-[30%] border-1 border-[#E9E9E9] rounded-xl py-4 px-6 md:px-4 flex flex-col gap-3 *: ${theme == "dark" ? "bg-black text-white" : "bg-white "
            } 
`}
        >
          <h2
            className={`font-pop text-gray-400 text-lg font-medium  *:
  ${theme == "dark" && "text-white"}`}
          >
            Total balance
          </h2>
          <h1
            className={`font-pop text-black font-semibold text-xl ${theme == "dark" && "text-white"}`}
          >
            ${user.PaymentBalance?.toFixed(2)}
          </h1>
          <p
            className={`font-pop cursor-pointer text-primarygreen text-base ${theme == "dark" && "text-white"}`}
            onClick={() => {
              navigate("/user-dashboard/withdraw/account");
            }}
          >
            Withdraw
          </p>
        </div>
      </div>

      <div className="my-6">
        <h2
          className={`  font-pop text-lg text-black font-semibold ${theme == "dark" && "text-white"}`}
        >
          Recent History
        </h2>
        <div className="my-4">
          <AmountHistory />
        </div>
      </div>
    </div>
  );
};

export default WithdrawHistory;
